import { Injectable } from "@angular/core";
import { GridsterConfig, GridsterItem } from "angular-gridster2";
import { UUID } from "angular2-uuid";
import { CompactType, DisplayGrid, GridType } from "angular-gridster2";
import { Subject } from "rxjs";

export interface IComponent {
  id: string;
  componentRef: string;
}
@Injectable({
  providedIn: "root",
})
export class LayoutService {
  public options: GridsterConfig = {
    draggable: {
      enabled: true,
    },
    pushItems: true,
    resizable: {
      enabled: true,
    },

    maxCols: 12, // Set maximum columns to 12
    minCols: 12, // Optionally, set minimum columns to 12 as well
    defaultItemCols: 12, // Optionally, set default item cols to 12
    displayGrid: DisplayGrid.Always, // Optionally, adjust display grid
    gridType: GridType.Fit, // Optionally, adjust grid type

    // compactType: CompactType.None, // Optionally, adjust compact type
    compactType: CompactType.CompactUp,
    itemResizeCallback: (item: GridsterItem) => {
      console.log(
        "Item Resized:",
        item.id,
        item.cols,
        item.rows,
        item.x,
        item.y
      );
    },
  };
  public layout: GridsterItem[] = [];
  public components: IComponent[] = [];
  public itemChangeSubject: Subject<GridsterItem[]> = new Subject<
    GridsterItem[]
  >();

  dropId: string;
  constructor() {}
  // addItem(): void {
  //   this.layout.push({
  //     cols: 12,
  //     id: UUID.UUID(),
  //     rows: 6,
  //     x: 0,
  //     y: 0,
  //     selectedChart: "",
  //   });
  // }
  addItem(
    reportId: any,
    reportName: any,
    name: any,
    chartName: any,
    xaxis: any,
    yaxis: any,
    customlink: any,
    title: any,
    subtitle: any,
    footer: any,
    maxgroupsdisplay: any,
    decimalplaces: any,
    displayunits: any,
    theme: any,
    showvalues: any,
    showpercentages: any,
    combinesmallgroups: any,
    showtotal: any,
    showrange: any,
    cumulative: any,
    stackfull: any,
    plotonsecondaxis: any
  ): void {
    const newItem: GridsterItem = {
      columns: 12,
      id: UUID.UUID(),
      rows: 6,
      x: 0,
      y: 0,
      selectedChart: "",
      reportid: reportId,
      reportname: reportName,
      name: name,
      charttype: chartName,
      xaxis: xaxis,
      yaxis: yaxis,
      customlink: customlink,
      title: title,
      subtitle: subtitle,
      footer: footer,
      maxgroupsdisplay: maxgroupsdisplay,
      decimalplaces: decimalplaces,
      displayunits: displayunits,
      theme: theme,
      showvalues: showvalues,
      showpercentages: showpercentages,
      combinesmallgroups: combinesmallgroups,
      showtotal: showtotal,
      showrange: showrange,
      cumulative: cumulative,
      stackfull: stackfull,
      plotonsecondaxis: plotonsecondaxis,
      cols: 12,
    };
    console.log(
      "New Item Added:",
      newItem.cols,
      newItem.rows,
      newItem.x,
      newItem.y
    );

    this.layout.push(newItem);
    this.itemChangeSubject.next(this.layout);
  }
  // deleteItem(id: string): void {
  //   const item = this.layout.find((d) => d.id === id);
  //   this.layout.splice(this.layout.indexOf(item), 1);
  //   const comp = this.components.find((c) => c.id === id);
  //   this.components.splice(this.components.indexOf(comp), 1);
  // }

  deleteItem(item: GridsterItem): void {
    const index = this.layout.findIndex((d) => d.id === item.id);

    if (index !== -1) {
      this.layout.splice(index, 1);
      this.itemChangeSubject.next([...this.layout]); // 🔥 refresh grid
    }

    const compIndex = this.components.findIndex((c) => c.id === item.id);
    if (compIndex !== -1) {
      this.components.splice(compIndex, 1);
    }
  }

  // deleteItem(id: string): void {
  //   const itemIndex = this.layout.findIndex((item) => item.id === id);
  //   if (itemIndex !== -1) {
  //     this.layout.splice(itemIndex, 1);
  //     this.itemChangeSubject.next(this.layout); // Emitting layout change
  //   }
  //   const componentIndex = this.components.findIndex((comp) => comp.id === id);
  //   if (componentIndex !== -1) {
  //     this.components.splice(componentIndex, 1);
  //   }
  // }
  editItem(result: any): void {
    console.log(result);
    // Find the index of the item in the layout array based on its unique identifier
    const index = this.layout.findIndex((item) => item.id === result.id);

    if (index !== -1) {
      // Update the item properties with the new values
      this.layout[index] = result;
      console.log("Updated item:", result);
    }
  }

  setDropId(dropId: string): void {
    this.dropId = dropId;
  }
  dropItem(dragId: string): void {
    const { components } = this;
    const comp: IComponent = components.find((c) => c.id === this.dropId);

    const updateIdx: number = comp
      ? components.indexOf(comp)
      : components.length;
    const componentItem: IComponent = {
      id: this.dropId,
      componentRef: dragId,
    };
    this.components = Object.assign([], components, {
      [updateIdx]: componentItem,
    });
  }
  getComponentRef(id: string): string {
    const comp = this.components.find((c) => c.id === id);
    return comp ? comp.componentRef : null;
  }

  handleItemResize(item: GridsterItem): void {
    const index = this.layout.findIndex(
      (layoutItem) => layoutItem.id === item.id
    );
    if (index !== -1) {
      console.log("Item Resized:", item.cols, item.rows, item.x, item.y);

      this.layout[index] = item;
      this.itemChangeSubject.next(this.layout); // Emitting layout change
    }
  }
}
